import * as types from '../actions/actionTypes'

export const initialState = {
  calculated: null,
  withdrawSucceeded: false,
}

export default function withdrawReducer(withdraw = initialState, action) {
  switch (action.type) {
    case types.CALCULATE_WITHDRAW:
    case types.CALCULATE_WITHDRAW_ERROR:
      return {
        ...withdraw,
        calculated: null,
      }
    case types.CALCULATE_WITHDRAW_SUCCESS:
      return {
        ...withdraw,
        calculated: action.payload,
      }
    case types.RESET_WITHDRAW_SUCCEEDED:
      return {
        ...withdraw,
        withdrawSucceeded: false,
      }
    case types.MAKE_WITHDRAW_SUCCESS:
      return {
        withdrawSucceeded: true,
      }
    default:
      return withdraw
  }
}

/*
  "calculated" examples:
{
  withdraw_amount: 7500, // 提領金額(台幣)
  withdraw_fee: 351, // 服務費(台幣)
  handling_fee: 35, // 金流處理費(台幣)
  calc_withdraw_amount: 7114, // 實領金額(台幣)
  exchange_rate: 31, // 台幣兌美元匯率
}
 */
